// PDP vertical thumb rail: keep the active thumbnail in view when aria-current moves (desktop only)
function initCmPdpThumbScroll() {
  if (!window.matchMedia('(min-width: 990px)').matches) return;
  var root = document.querySelector('.cm-pdp-root');
  if (!root) return;
  var list = root.querySelector('media-gallery .thumbnail-list');
  if (!list) return;

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.attributeName !== 'aria-current') return;
      var thumb = mutation.target;
      if (thumb.getAttribute && thumb.getAttribute('aria-current') === 'true') {
        thumb.scrollIntoView({ block: 'nearest' });
      }
    });
  });

  observer.observe(list, {
    attributes: true,
    attributeFilter: ['aria-current'],
    subtree: true,
  });
}

// Device select: WCAG 3.2.2 forbids arrow-key changes auto-navigating, so only pointer/touch picks or Enter do
function initCmSwitcherSelect() {
  var selects = document.querySelectorAll('.cm-switcher__select');
  selects.forEach(function (select) {
    var pointerPick = false;
    // a band lists every model of its size group behind one URL, so picking a fitting model must not reload
    var go = function () {
      if (!select.value || select.value === window.location.pathname) return;
      window.location.href = select.value;
    };
    select.addEventListener('pointerdown', function () {
      pointerPick = true;
    });
    select.addEventListener('touchstart', function () {
      pointerPick = true;
    });
    select.addEventListener('change', function () {
      var wasPointerPick = pointerPick;
      pointerPick = false;
      if (wasPointerPick) go();
    });
    select.addEventListener('keydown', function (event) {
      // an opened-then-abandoned dropdown must not turn the next arrow key into a navigation
      pointerPick = false;
      if (event.key !== 'Enter') return;
      go();
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCmPdpThumbScroll);
  document.addEventListener('DOMContentLoaded', initCmSwitcherSelect);
} else {
  initCmPdpThumbScroll();
  initCmSwitcherSelect();
}
